import { trigger, transition, style, animate } from '@angular/animations';

export const mobileMenuAnimations = [
  trigger('enterAnimationSide', [
    transition(':enter', [
      style({
        position: 'absolute',
        transform: 'translateX(100%)',
        backgroundColor: '#1C1C1C',
      }),
      animate(
        '700ms cubic-bezier(0,0,.15,1)',
        style({ transform: 'translateX(0)', position: 'absolute' })
      ),
    ]),
    transition(':leave', [
      style({
        transform: 'translateX(0)',
        position: 'absolute',
        backgroundColor: '#1C1C1C',
      }),
      animate(
        '700ms cubic-bezier(0,0,.15,1)',
        style({ transform: 'translateX(100%)', position: 'absolute' })
      ),
    ]),
  ]),
  trigger('fadeOut', [
    transition(':enter', [
      style({ position: 'absolute', opacity: 0 }),
      animate('700ms', style({ opacity: 1 })),
    ]),
    transition(':leave', [
      style({ position: 'absolute', opacity: 1 }),
      animate('700ms', style({ opacity: 0 })),
    ]),
  ]),
];
